import { useState, useEffect, useCallback } from 'react';

import * as fp from 'lodash/fp';

import getStores from '~/algolia/getStores';

import { FetchingDataStatus } from '~/types/utilities';
import { AlgoliaStore } from '~/types/store/store';

export default function useStoreList(storesId: Array<string>) {
  const [fetchingStatus, setFetchingStatus] = useState<FetchingDataStatus>(FetchingDataStatus.INIT);

  const [storeList, setStoreList] = useState<Array<AlgoliaStore>>([]);

  const handleFetchStoresList = useCallback(
    async (storesId: Array<string>) => {
      try {
        setFetchingStatus(FetchingDataStatus.LOADING);
        const res = await getStores(storesId);

        const stores = res.results.filter((store) => !!store) as Array<AlgoliaStore>;
        setFetchingStatus(FetchingDataStatus.SUCCESS);
        setStoreList(stores);
      } catch (err) {
        setFetchingStatus(FetchingDataStatus.FAIL);
      }
    },
    [setStoreList, setFetchingStatus],
  );

  useEffect(() => {
    if (fp.gt(storesId.length, 0)) {
      handleFetchStoresList(storesId);
      return;
    }

    setStoreList([]);
  }, [storesId]);

  return { storeList, fetchingStatus };
}
